import React from 'react';
import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

const EmptyState = ({ title, description, textSize = 'h6' }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '48px',
        textAlign: 'center',
        backgroundColor: '#f8f9fa',
        borderRadius: '8px',
        border: '1px dashed #dee2e6'
      }}
    >
      <Typography
        variant={textSize}
        sx={{
          color: '#6c757d',
          marginBottom: '8px',
          fontWeight: 500
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: '#adb5bd',
          maxWidth: '400px'
        }}
      >
        {description}
      </Typography>
    </Box>
  );
};

EmptyState.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
};

export default EmptyState; 